import React from 'react';
import { Row } from './Row';

export const Event = ({ event: { type, timestamp, ...rest }, system }) => {
    const types = {
        "onEventOmid": "OMID",
        "onEventGeneral": "General",
        "onEventVast": "VAST",
        "onEventVpaid": "VPAID"
    };
    let typeName = system === "LoopMe" ? types[type.replace(/_/g, ' ').split('/')[1]] : type;
    if (!typeName) {
        return null;
    }

    let eventName = rest?.payload?.event;
    if (system === "Google") {
        typeName = '';
        eventName = type;
    }
    return (
        <>
            <Row>
                <div>{timestamp}</div>
                <div>{typeName}</div>
                <div>{eventName}</div>
            </Row>
            <Row style={{display: 'none'}}>
                <div><pre>{JSON.stringify(rest.payload,null,2)}</pre></div>
            </Row>
        </>
    );
};
